(() => {
  const key = 'heyhome:favorites:v1';
  const icon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"/></svg>';
  let enabled = false;
  let items = [];

  function read() {
    try {
      const test = key + ':test';
      localStorage.setItem(test, '1');
      localStorage.removeItem(test);
      const data = JSON.parse(localStorage.getItem(key) || '[]');
      enabled = true;
      items = Array.isArray(data) ? data.filter(item =>
        item && /^ST-\d{4}$/.test(item.id) && typeof item.title === 'string'
      ).slice(0, 100) : [];
    } catch (_) {
      enabled = false;
      items = [];
    }
  }

  function save() {
    try {
      localStorage.setItem(key, JSON.stringify(items));
      return true;
    } catch (_) {
      enabled = false;
      return false;
    }
  }

  function cardData(card) {
    const title = card.querySelector('h3')?.textContent?.trim();
    if (!title) return null;
    const model = card.querySelector('[data-hh-product-model]')?.dataset.hhProductModel;
    let match = model?.match(/^ST-(\d{4})$/) || title.match(/\bST[-\s]?(\d{4})\b/i);
    if (!match) {
      const url = card.querySelector('a[href*="wa.me/"][href*="ST-"]')?.href;
      if (url) match = new URL(url).searchParams.get('text')?.match(/\bST[-\s]?(\d{4})\b/i);
    }
    return match ? { id: 'ST-' + match[1], title: title.slice(0, 160) } : null;
  }

  function addButtons(root = document) {
    if (!enabled) return;
    root.querySelectorAll('.hh-catalog-media, .hh-products .hh-product').forEach(node => {
      const card = node.classList.contains('hh-product') ? node : node.closest('.group-block');
      if (!card || card.querySelector('.hh-favorite-toggle')) return;
      const data = cardData(card);
      if (!data) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'hh-favorite-toggle';
      button.dataset.hhFavorite = data.id;
      button.dataset.hhTitle = data.title;
      button.setAttribute('aria-label', 'Guardar ' + data.title + ' en favoritos');
      button.setAttribute('aria-pressed', 'false');
      button.innerHTML = icon;
      card.style.position = 'relative';
      card.append(button);
    });
  }

  function render() {
    document.querySelectorAll('[data-hh-favorites-open]').forEach(button => {
      button.hidden = !enabled;
    });
    document.querySelectorAll('[data-hh-favorites-count]').forEach(count => {
      count.textContent = String(items.length);
    });
    document.querySelectorAll('[data-hh-favorite]').forEach(button => {
      button.hidden = !enabled;
      const saved = items.some(item => item.id === button.dataset.hhFavorite);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label',
        (saved ? 'Quitar ' : 'Guardar ') + button.dataset.hhTitle +
        (saved ? ' de favoritos' : ' en favoritos'));
      button.querySelector('svg')?.setAttribute('fill', saved ? 'currentColor' : 'none');
    });
    const list = document.querySelector('[data-hh-favorites-list]');
    if (!list) return;
    list.replaceChildren();
    const status = document.querySelector('[data-hh-favorites-status]');
    if (status) status.textContent = !enabled ? 'No se pudo guardar en este navegador.' : (items.length ? '' : 'Todavía no tienes productos guardados.');
    items.forEach(item => {
      const li = document.createElement('li');
      const name = document.createElement('span');
      name.textContent = item.title;
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.dataset.hhFavoriteRemove = item.id;
      remove.textContent = 'Quitar';
      remove.setAttribute('aria-label', 'Quitar ' + item.title + ' de favoritos');
      li.append(name, remove);
      list.append(li);
    });
  }

  function init(root = document) {
    read();
    addButtons(root);
    render();
  }

  document.addEventListener('click', event => {
    const open = event.target.closest('[data-hh-favorites-open]');
    if (open) {
      const dialog = document.getElementById('hh-favorites-dialog');
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }
    const close = event.target.closest('[data-hh-favorites-close]');
    if (close) {
      close.closest('dialog')?.close();
      return;
    }
    const toggle = event.target.closest('[data-hh-favorite]');
    if (toggle && enabled) {
      const id = toggle.dataset.hhFavorite;
      const index = items.findIndex(item => item.id === id);
      if (index >= 0) items.splice(index, 1);
      else if (items.length < 100) items.push({ id, title: toggle.dataset.hhTitle });
      save();
      render();
      return;
    }
    const remove = event.target.closest('[data-hh-favorite-remove]');
    if (remove && enabled) {
      items = items.filter(item => item.id !== remove.dataset.hhFavoriteRemove);
      save();
      render();
      return;
    }
    document.querySelectorAll('.hh-top-account[open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      document.querySelectorAll('.hh-top-account[open]').forEach(details => details.open = false);
    }
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  window.addEventListener('storage', event => {
    if (event.key === key) init();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
